module.exports = __webpack_public_path__ + "a3482ea3104b1793263f89dd1069130a.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/hooman.msgpack
 ** module id = 595
 ** module chunks = 0
 **/